import './About.css'

export default function About() {
  return (
    <div className="about-app">
      <header className="about-header">
        <pre className="about-logo">{`
╔═══════════════════════════════════════════════════════════╗
║  ██████╗ ███████╗██████╗ ███████╗ ██████╗ ███╗   ██╗ █████╗ ║
║  ██╔══██╗██╔════╝██╔══██╗██╔════╝██╔═══██╗████╗  ██║██╔══██╗║
║  ██████╔╝█████╗  ██████╔╝███████╗██║   ██║██╔██╗ ██║███████║║
║  ██╔═══╝ ██╔══╝  ██╔══██╗╚════██║██║   ██║██║╚██╗██║██╔══██║║
║  ██║     ███████╗██║  ██║███████║╚██████╔╝██║ ╚████║██║  ██║║
║  ╚═╝     ╚══════╝╚═╝  ╚═╝╚══════╝ ╚═════╝ ╚═╝  ╚═══╝╚═╝  ╚═╝║
║                    S C I E N C E                           ║
╚═══════════════════════════════════════════════════════════╝
        `}</pre>
      </header>

      <section className="about-section">
        <h2>// PERSISTENT IDENTITY INTELLIGENCE</h2>
        <p>
          Persona Science is at the forefront of <strong>Persistent Identity Intelligence</strong>,
          developing software and algorithms to construct rich "personas" of both trusted
          individuals and bad actors across digital and physical domains.
        </p>
      </section>

      <section className="about-section">
        <h2>// MISSION</h2>
        <p>
          Our mission is to <strong>fuse multi-signal and side-channel data</strong> – from browser
          and network-stack fingerprints to facial recognition, license plate scans, and RF
          emissions – into a unified identity picture.
        </p>
      </section>

      <section className="about-section">
        <h2>// CAPABILITIES</h2>
        <ul className="about-list">
          <li>► Biometric Recognition (Face, Gait, Whole-Body)</li>
          <li>► Browser & Network Fingerprinting</li>
          <li>► RF Signal Intelligence & Side-Channel Analytics</li>
          <li>► Multi-Domain Fusion Platform</li>
          <li>► Real-Time Entity Resolution</li>
          <li>► Embedded Edge Devices</li>
        </ul>
      </section>

      <section className="about-section">
        <h2>// CLIENTS</h2>
        <p>
          We serve the <strong>U.S. Department of Defense (DoD)</strong>, intelligence agencies,
          and <strong>NATO allies</strong> with end-to-end solutions for threat detection and
          identity intelligence.
        </p>
      </section>

      <footer className="about-footer">
        <pre>{`
┌─────────────────────────────────────────────┐
│  CLASSIFICATION: UNCLASSIFIED               │
│  © 2025 Persona Science. All Rights Reserved│
└─────────────────────────────────────────────┘
        `}</pre>
      </footer>
    </div>
  )
}
